import React from 'react'
import { Paper, Card, CardContent, Grid, Typography, useTheme, useMediaQuery } from '@material-ui/core'
import {
  Movie as MovieIcon,
  Games as GamesIcon,
  EmojiEmotionsTwoTone as EmojiEmotionsIcon
} from '@material-ui/icons'
import { Link } from 'react-router-dom'
import { useStore } from '../../context/Context'
import useStyles from './styles'

const Dashboard = () => {
  const classes = useStyles()
  const theme = useTheme()
  const matchSM = useMediaQuery(theme.breakpoints.down('sm'))
  const { listMovies, listGames } = useStore()

  return (
    <main className={classes.root}>
      <Paper elevation={0} className={classes.paper}>
        <Grid container justifyContent="space-between" spacing={3} direction={matchSM ? 'column' : 'row'}>
          <Grid item md>
            <Card variant="outlined">
              <CardContent>
                <Grid container alignItems="center">
                  <Typography variant="h5" color="textSecondary" className={classes.pushRight}>Movie Total</Typography>
                  <MovieIcon color="action" />
                </Grid>
                <Typography variant="h6">{listMovies.length} {listMovies.length > 1 ? 'items' : 'item'}</Typography>
                <Link to="/movies" className={classes.link}>See movies</Link>
              </CardContent>
            </Card>
          </Grid>
          <Grid item md>
            <Card variant="outlined">
              <CardContent>
                <Grid container alignItems="center">
                  <Typography variant="h5" color="textSecondary" className={classes.pushRight}>Game Total</Typography>
                  <GamesIcon color="action" />
                </Grid>
                <Typography variant="h6">{listGames.length} {listGames.length > 1 ? 'items' : 'item'}</Typography>
                <Link to="/games" className={classes.link}>See games</Link>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Card variant="outlined" className={classes.box}>
          <CardContent>
            <Grid container justifyContent="center" alignItems="center" direction="column">
              <EmojiEmotionsIcon color="primary" style={{ fontSize: '16rem' }} />
              <Typography variant="h3" align="center">Welcome Back!</Typography>
            </Grid>
          </CardContent>
        </Card>
      </Paper>
    </main>
  )
}

export default Dashboard
